import { useContext, useEffect, useState } from 'react';
import { CustomerPrivacySecurityContext } from '../../context/CustomerPrivacySecurityContext';
export const useExpander = _ref => {
  let {
    totalCount,
    maxCount,
    onChange
  } = _ref;
  const hasMorePointsThanLimit = totalCount > maxCount;
  const [showExpandButton, setShowExpandButton] = useState(hasMorePointsThanLimit);
  const {
    areAllSectionsExpanded
  } = useContext(CustomerPrivacySecurityContext);
  const expanderClicked = () => {
    setShowExpandButton(false);
    onChange(totalCount);
  };
  useEffect(() => {
    const showButton = areAllSectionsExpanded ? false : hasMorePointsThanLimit;
    const visibleCount = areAllSectionsExpanded ? totalCount : maxCount;
    setShowExpandButton(showButton);
    onChange(visibleCount);
  }, [areAllSectionsExpanded]);
  useEffect(() => {
    const numberOfPointsVisible = showExpandButton ? maxCount : totalCount;
    // onMount do first render of all the items
    onChange(numberOfPointsVisible);
  }, []);
  return {
    showExpandButton,
    expanderClicked
  };
};